import Cookies from 'js-cookie';

export const getAndSendFingerprint = async (store) => {
    try {
        let visitorId = Cookies.get('fingerprint_id'); // Ambil ID dari cookies

        if (!visitorId) {
            // FingerprintJS (~135 KB) hanya dibutuhkan pengunjung yang BELUM punya cookie
            // fingerprint_id — sekali seumur setahun. Impor statis membuat semua orang
            // mengunduhnya di chunk awal, termasuk pengunjung berulang yang tak memakainya.
            const { default: FingerprintJS } = await import(
                /* webpackChunkName: "fingerprintjs" */ "@fingerprintjs/fingerprintjs"
            );
            // Jika tidak ada di cookies, generate fingerprint baru
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            visitorId = result.visitorId;

            // Simpan fingerprint di cookies dengan masa berlaku 1 tahun
            Cookies.set('fingerprint_id', visitorId, { expires: 365, path: '/' });
        }

        // console.log("Visitor ID:", visitorId);
        store.commit('user/setFingerprintId', visitorId);

        // Kirim visitorId ke backend
        await store.dispatch('user/sendFingerprint', visitorId);
        console.log('SENDF', 1)
        // console.log("Visitor ID sent to backend successfully.");
    } catch (error) {
        console.error("Error in sending fingerprint:", error);
    }
};